import { Features } from '../constants/features';
import { usePlanFeatureGate } from './use-plan-feature-gate';

export const useDashboardsViewOnlyFeatureGate = () => usePlanFeatureGate(Features.DashboardsViewOnly);
